import { isFeatureEnabled } from 'owa-feature-flags';
import { isEdu } from 'owa-nonboot-userconfiguration-manager';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';

export function isGetMobileFeatureEnabled(): boolean {
    /* WI 61856*/
    return (
        isFeatureEnabled('emptyState-GetOutlookMobile') &&
        !isBrowserIE() &&
        (isConsumer() || isEdu())
    );
}
